import { render } from "./ShowIncidence.vue?vue&type=template&id=550fd2d4&scoped=true"
import script from "./ShowIncidence.vue?vue&type=script&lang=js"
export * from "./ShowIncidence.vue?vue&type=script&lang=js"

import "./ShowIncidence.vue?vue&type=style&index=0&id=550fd2d4&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550fd2d4"]])

export default __exports__